// extracted by mini-css-extract-plugin
export var hidden = "_53-1";
export var leftPanel = "_53-2";
export var readonlyInspector = "_53-3";
export var rightPanel = "_53-0";